import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=af46a2d0&scoped=true&"
import script from "./Outbound.vue?vue&type=script&lang=js&"
export * from "./Outbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af46a2d0",
  null
  
)

export default component.exports